import i18n from "../../../config/i18n";
import type { SupportedLanguage } from "../../../interfaces";
import { normalizeLanguage } from "./langUtils";

type Translatable = {
  translations: Record<SupportedLanguage, string | null>;
};

export function getItemTranslation(
  item: Translatable,
  lang = i18n.resolvedLanguage
) {
  // normalizeLanguage lowercases + strips any region suffix ("fr-FR" -> "fr")
  // and defaults to "en"; a strict enum parse would silently fall back to
  // English for region-coded locales (common in iOS WKWebView).
  const validLang = normalizeLanguage(lang);
  return item.translations[validLang] ?? item.translations["en"] ?? "";
}
